import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-urgent-mail-icon',
  templateUrl: './communication-urgent-mail.component.html'
})
export class CommunicationUrgentMailComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
